export default "data:video/mp2t;base64,ZXhwb3J0IGNvbnN0IFJFRkVUQ0hfSU5URVJWQUxTID0gewogIERFRkFVTFQ6IDEwICogMTAwMCwKICBGSUxFX1BST0NFU1NJTkc6IDMwICogMTAwMCwKfTsK"